import {Pipe, PipeTransform} from '@angular/core';
import {BaseTask, EmployeeWorkShift, PatientTaskView} from "planner-shared";

@Pipe({
    name: 'fromto',
    pure: false,
    standalone: false
})
export class FromtoPipe implements PipeTransform {

    transform(timeRangeObj: BaseTask | EmployeeWorkShift | PatientTaskView): string {
        return timeRangeObj.fromTime + ' - ' + timeRangeObj.toTime;
    }

}
